export default "__VITE_ASSET__BMUAK6HS__"